import { apiGet } from "../core/request";

export type Country = {
  name: string;
  iso: string;
  dial_code?: string;
  emoji?: string;
};

/** Fetch all countries (from config/countries.php via CountryApiController) */
export async function apiCountriesIndex(): Promise<Country[]> {
  const res = await apiGet("/xapi/countries");
  return res.data ?? res;
}
